import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { Dispatch } from 'redux'

import SaveSearchButton from '@cinch/oxd-components/save-search/src'
import { FORM_NAME } from '@cinch/oxd-containers/dealer-listing-filters/src'
import { actions as profileActions } from '@cinch/oxd-redux/profile/src'
import { getLocation } from '@cinch/oxd-redux/profile/src/selectors'

export const mapStateToProps = (state: any) => ({
  isAuthenticated: !!(state.oidc && state.oidc.user),
  formFilters: getFormValues(FORM_NAME)(state),
  location: getLocation(state).location,
})

export const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  saveSearch: (name: string, filters: Cinch.FilterFormData, location: string) =>
    dispatch(profileActions.saveSearch(name, filters, location)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SaveSearchButton)
